import React from "react";
//Utils
import { calculateAge, dateToString } from "../../utils";
// Components
import RowCard from "../generic/RowCard";
// Styled
import styled from "styled-components";
// React Router
import { useHistory } from "react-router-dom";
import { context } from "../../contexto";

const CardHermanaConfig = styled(RowCard).attrs(props => ({

  grayscale: props.active ? 0 : 100,
  shadow: props.active ? "0 0px 6px #2a599f !important" : "0 0px 6px #93a1b4 !important"

}))`

  -webkit-filter: grayscale(${props => props.grayscale}); /* Safari 6.0 - 9.0 */
  filter: grayscale(${props => props.grayscale});
  
  :hover {
    box-shadow: ${props => props.shadow};
  }

`;

const HermanaTarjetaConfiguracion = ({ content, nivelSeleccionado, ...props }) => {

  let history = useHistory();

  // Procesamiento de los datos de las hermanas
  //console.log(content)
  let img = content.photo ? `${process.env.REACT_APP_API_URL}/download/usuarios/${content.id}` : content.sister ? "/images/nun.png" : content.gender === 'h' ? "/images/laico1.png" : "/images/laico2.png";
  let imgOnError = content.sister ? "/images/nun.png" : content.gender === 'h' ? "/images/laico1.png" : "/images/laico2.png";
  let title = `${content.name} ${content.firstSurname} ${content.secondSurname}`;
  let years = content.birthdate ? `${dateToString(content.birthdate)}` : "";
  let address = content.birthCountry ? `${content.birthCountry}` : "";
  
//console.log({contenido:content})
// { img: { url: "/images/province.png", size: 20, title: "Provincia" }, value: content.sister?.destinations[0] ? content.sister?.destinations[0]?.province.name : "No asignada" },
  let body = [
    { img: { url: "/images/province.png", size: 20, title: "Provincia" }, value: content.type === 'Monja' ? content.sister?.destinations[0] ? content.sister?.destinations[0]?.province.name : "No asignada" : content.destinationLaicos[0] ? content.destinationLaicos[0].province.name : 'No asignada'},
    content.type === 'Monja' && { img: { url: "/images/comunidad.png", size: 20, title: "Comunidad" }, value: content.sister?.destinations[0] ? content.sister?.destinations[0]?.community.name : "No asignada" }
  ];

  return (
    <>
    {//console.log(imgOnError)
    }
       <CardHermanaConfig
          active={(content.active && !content.sister?.decease)}  
          cardImage={{imagen:img, onClick:(() => history.push(`${content.sister ? 'hermanas' : 'laicos'}/${content.id}`))}} 
          title={title} 
          body={body} 
          imgOnError={imgOnError} 
          id={content.id}
          accessLevel={nivelSeleccionado}
          content={content}
          {...props}
        />
     
    </>

  );
};

export default HermanaTarjetaConfiguracion;
